<template>
  <section>
    <!--<header class="mui-bar mui-bar-nav">-->
      <!--<a class="mui-action-back mui-icon mui-icon-left-nav mui-pull-left"></a>-->
      <!--<h1 class="mui-title">取样判定详情</h1>-->
    <!--</header>-->
    <div class="mui-content">
        <div class="title-name">
          <span class="">取样判定详情</span>
        </div>
        <div style="padding-top: 15px;">
          <!--第一行-->
          <div class="form-group">
            <div class="input-label">
              <label >外注订单：</label>
            </div>
            <div class="form-input form-group-new" >
              {{sampleinfo.ddh}}
            </div>          
          </div>
          <div class="form-group">
            <div class="input-label">
              <label >物料：</label>
            </div>
            <div class="form-input form-group-new" >
              {{sampleinfo.scxtwph+" "+sampleinfo.scxtwpmc}}
            </div>
          </div>   
          <div class="form-group">
            <div class="input-label">
              <label >坯布品番：</label>
            </div>
            <div class="form-input form-group-new" >
              {{sampleinfo.clothcode}}
            </div>          
          </div>
          <div class="form-group">
            <div class="input-label">
              <label >取样机台：</label>
            </div>
            <div class="form-input form-group-new" >
              {{sampleinfo.machineno}}
            </div>
          </div>      
          <div class="form-group">
            <div class="input-label">
              <label >取样轴号：</label>
            </div>
            <div class="form-input form-group-new" >
              {{sampleinfo.rollernumber}}
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label >取样位置：</label>
            </div>
            <div class="form-input form-group-new" >
               {{sampleinfo.locationname}}
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label >取样日期：</label>
            </div>
            <div class="form-input form-group-new" >
              {{sampleinfo.sampletime}}
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label >取样数量：</label>
            </div>
            <div class="form-input form-group-new" >
              {{sampleinfo.amount}}米
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label >取样人：</label>
            </div>
            <div class="form-input form-group-new" >
              {{sampleinfo.sampleuser}}
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label >判定人：</label>
            </div>
            <div class="form-input form-group-new" >
              <input type="text" style="flex: 6;" :disabled="(determineuserflg=='1') || (determineuserflg=='0')" v-model="info.determineuser_name"/>
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label >判定日期：</label>
            </div>
            <div class="form-input form-group-new" >
              <input type="text" style="flex: 6;" :disabled="(determineuserflg=='1') || (determineuserflg=='0')" :data-options='dataoptions' v-model="info.determinetime" @tap="showpicker"/>
            </div>
          </div>
          <div class="form-group">
            <label class="input-label">判定等级：</label>
            <div class="form-input" style="padding-top: 4px;">
              <div class="mui-input-row mui-radio mui-left">
                <label style="font-size: 14px;">A</label>
                <input type="radio" name="determinegrade" v-model="info.determinegrade" value="A" :disabled="determineuserflg=='1'">
              </div>
              <div class="mui-input-row mui-radio mui-left">
                <label style="font-size: 14px;">C</label>
                <input type="radio" name="determinegrade" v-model="info.determinegrade" value="C" :disabled="determineuserflg=='1'">
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="input-label">
              <label >备注：</label>
            </div>
            <div class="form-input form-group-new" >
              <textarea name="" rows="" cols="" v-model="info.remark" :disabled="determineuserflg=='1'"></textarea>
            </div>
          </div>
          <div class="form-group" style="width:100%;margin-bottom: 30px;">
            <button type="button" class="mui-btn mui-btn-primary btn-blue" v-show="determineuserflg=='0'" style="margin: auto;width: 80px;" @tap="save">保存</button>
          </div>
        </div>
    </div>
  </section>
</template>

<script>
    import "../../static/js/mui.picker.min.js";
    export default {
      name: "samplingDetermine",
      data(){
        return{
          paraInfo:{ddh:"",wph:"",scxtwph:"",scxtwpmc:"" },
          determineuserflg:"0",
          dataoptions:'{"type":"date"}',
          sampleinfo:{},// 取样信息
          info: {
                  sampleno: "",// 取样单号
                  machineno: "",// 机台号
                  yarnsno: "",// 取样纱
                  ddqf: "",// 订单区分
                  ddh: "",// 订单号
                  wph: "",// 物料号
                  determineuser_name: "",// 判定人
                  determineuser:"",
                  determinetime: "",// 判定时间
                  determinegrade:"A",// 判定等级
                  remark: "",// 判定备注
                  clothcode: "",// 坯布区分
                  rollernumber: ""// 轴号
              },// 判定信息
          tsddetermineinfo:{}// TSD判定结果
        }
      },
      methods:{
        showpicker(){
          var v=this;
          var dDate = new Date();
          var optionsJson = v.dataoptions;
          var options = JSON.parse(optionsJson);
          var picker = new mui.DtPicker(options);
          picker.show(function (rs) {
            console.log(rs)
            var timestr = rs.text;
            v.info.determinetime=timestr.replace(/-/g,"/");
            picker.dispose();
          });
        },
        getFormatDate(date) {
          var seperator1 = "/";
          var year = date.getFullYear();
          var month = date.getMonth() + 1;
          var strDate = date.getDate();
          if (month >= 1 && month <= 9) {
              month = "0" + month;
          }
          if (strDate >= 0 && strDate <= 9) {
              strDate = "0" + strDate;
          }
          var currentdate = year + seperator1 + month + seperator1 + strDate;
          return currentdate;
        },
        save(){
          var v=this;
          if(v.info.determineuser==""){
           mui.toast("请输入判定人！");
           return;
          }
          v.nyy.doPost("/Sample/saveDetermine",v.info, 
            function(result){
              if(result.status){
                 //v.$router.push({"name":"samplingHis",params: jsonPara(v.paraInfo)});
                 v.$router.go(-1);
              } else {
                  mui.toast(result.message);
                  return;
              }
            }
          );
        }
      },
      activated() {
        var v=this;
        var para = getJsonPara(v.$route);
        var sampleno=para.sampleno;
        v.determineuserflg=para.determineuserflg;
        v.paraInfo.ddh=para.ddh;
        v.paraInfo.wph=para.wph;
        v.paraInfo.scxtwph=para.scxtwph;
        v.paraInfo.scxtwpmc=para.scxtwpmc;
        var date = new Date();//获取当前时间
        var now_date = v.getFormatDate(date);
        v.nyy.doPost("/Sample/getSampleDetail",{sampleno:sampleno,showinfoflg:v.determineuserflg,ddqf:""}, 
          function(result){
            if(result.status){
              v.sampleinfo=result.data.info;
              if(v.determineuserflg=="1"){
                v.tsddetermineinfo=result.data.dinfo;
              }
              v.info.sampleno = v.sampleinfo.sampleno;
              v.info.machineno = v.sampleinfo.machineno;
              v.info.yarnsno = v.sampleinfo.yarnsno;
              v.info.ddh = v.sampleinfo.ddh;
              v.info.wph = v.sampleinfo.wph;
              v.info.clothcode = v.sampleinfo.clothcode;
              v.info.rollernumber = v.sampleinfo.rollernumber;
              v.info.determinetime = (v.determineuserflg=="1") ? v.tsddetermineinfo.determinetime: now_date;
              v.info.determineuser_name = (v.determineuserflg=="1") ? v.tsddetermineinfo.determineuser: result.data.uname;
              v.info.determineuser = (v.determineuserflg=="1") ? v.tsddetermineinfo.determineuser: result.data.ucode;
              v.info.determinegrade = (v.determineuserflg=="1") ? v.tsddetermineinfo.determinegrade: "A";
              v.info.remark = (v.determineuserflg=="1") ? v.tsddetermineinfo.remark: "";
            }else {
                mui.toast(result.message);
                return;
            }
          }
        );
       
      },
      watch:{
         info: {
            handler: function (val) {
                this.info.determineuser = isText(val.determineuser);
            },
            deep: true
          }
      }
    }
</script>

<style scoped>
  @import "../../static/css/mui.picker.min.css";
  @import "../../static/css/filterorder.css";
  @import "../../static/css/sampling.css";
  @import "../../static/css/update.css";
</style>



// WEBPACK FOOTER //
// src/components/samplingDetermine.vue